import slugify from "slugify"
import { Paths } from "#/utils/Paths"
import type { HelpCenterArticle } from "./types"

export function helpCenterCategoryPath(categorySlug: string): string {
  return `${Paths.FAQS}/categories/${categorySlug}`
}

export function helpCenterArticlePath(article: Pick<HelpCenterArticle, "id" | "title">): string {
  const vanity = slugify(article.title, { lower: true, strict: true })
  return `${Paths.FAQS}/${vanity}-${article.id}`
}

export function parseArticleIdFromPath(vanityAndId: string): string {
  const lastDash = vanityAndId.lastIndexOf("-")
  return lastDash < 0 ? "" : vanityAndId.slice(lastDash + 1)
}
